import React from 'react';
import axios from "axios";
import {
    ChartReportModel,
    GetDashboardReportSectionOne,
    LastDisk,
    LastPaysModel,
    LastUserModel,
    resultDashboard
} from './model'
const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/api/v3/AccountingManagment`


const GetDashboardReportSectionOneApi = () => {
    return axios
        .get<GetDashboardReportSectionOne>(`${USER_URL}/GetDashboardReportSectionOne`)
}
const LastUserLogins = (date? :string) => {
    const post = {
        dateString : date
    }
    return axios
        .post<resultDashboard<LastUserModel[]>>(`${USER_URL}/LastUserLogins`,post)
}
const LastUserRegistar = (date? :string) => {
    const post = {
        dateString : date
    }
    return axios
        .post<resultDashboard<LastUserModel[]>>(`${USER_URL}/LastUserRegistar`,post)
}
const LastPays = (date? :string) => {
    const post = {
        dateString : date
    }
    return axios
        .post<resultDashboard<LastPaysModel[]>>(`${USER_URL}/LastPays`,post)
}
const LastDisks = (date? :string) => {
    const post = {
        dateString : date
    }
    return axios
        .post<resultDashboard<LastDisk[]>>(`${USER_URL}/LastDisks`,post)
}
const GetSaleReportChart = (day? :number) => {

    return axios
        .get<ChartReportModel[]>(`${USER_URL}/GetSaleReportChart/${day ? day : 7}`,)
}
export {GetDashboardReportSectionOneApi,LastDisks,LastUserRegistar,LastUserLogins,LastPays,GetSaleReportChart}
